module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/acuerdo/acuerdo.component.html
// module id = ./src/app/acuerdo/acuerdo.component.html
// module chunks = main